export enum EVrmDeviceType {
  GATEWAY = "GATEWAY",
  BATTERY_MANAGEMENT_SYSTEM = "BATTERY_MANAGEMENT_SYSTEM",
  BATTERY_MONITOR = "BATTERY_MONITOR",
  SOLAR_CHARGER = "SOLAR_CHARGER",
  TANK_SENSOR = "TANK_SENSOR",
  TEMPERATURE_SENSOR = "TEMPERATURE_SENSOR",
  INVERTER = "INVERTER",
}
